<template>
  <body>
    <div id="client-layout">
      <div class="container-fluid">
        <nav class="row">
          <div class="col-1">
            <Side />
          </div>
          <div class="col-11">
            <main>
              <router-view />
            </main>
          </div>
        </nav>
      </div>
    </div>
  </body>
</template>

<script>
import Side from "./compontens/Side.vue";

export default {
  components: {
    Side,
  },
};
</script>

<style scoped>
.container-fluid {
  padding-left: 0;
}

#client-layout {
  background: #fef9ff;
}
</style>